import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import UserBadge from "../../UserBadge";
import hornSound from "../../Utils/audio/horn-sound.mp3";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUser } from "../../API/fetchExpressAPI";
import CustomSnackbar from "../../Components/CustomSnackbar";
import bg_img from "../../Utils/images/Socialize/city_junctions/connect_with_utilities/municipal_corporation/municipal-corporation_bg.webp"
import vendor_commission_services from "../../Utils/images/Socialize/city_junctions/connect_with_utilities/municipal_corporation/vendor_commission_services.webp"
import grievance_form from "../../Utils/images/Socialize/city_junctions/connect_with_utilities/municipal_corporation/grievance_form.webp"
import trade_license from "../../Utils/images/Socialize/city_junctions/connect_with_utilities/municipal_corporation/trade_license.webp"
import services_by_municipal_corporation from "../../Utils/images/Socialize/city_junctions/connect_with_utilities/municipal_corporation/services_by_municipal_corporation.webp"

function MunicipalCorporation() {
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.userAccessToken);
  const [audio] = useState(new Audio(hornSound));
  const [isShopUser, setIsShopUser] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  useEffect(() => {
    const fetchUserType = async () => {
      if (!token) {
        setIsShopUser(false);
        return;
      }

      try {
        const resp = await getUser(token);
        setIsShopUser(resp?.[0]?.user_type === "shop");
      } catch (error) {
        console.error("Error fetching user type:", error);
        setIsShopUser(false);
      }
    };

    fetchUserType();
  }, [token]);

  const handleServiceClick = (e, serviceId) => {
    e.preventDefault();
    
  };

  const handleGrievanceClick = (e) => {
    e.preventDefault();
    const target = e.target.closest(".grievance_license_container");
    if (target) {
      target.classList.add("reduceSize3");
      audio.play();
      
      setTimeout(() => {
        target.classList.remove("reduceSize3");
      }, 300);
      
      setTimeout(() => {
        navigate("grievance-form");
      }, 600);
    }
  };

  const handleVendorClick = (e) => {
    e.preventDefault();
    const target = e.target.closest(".vendor_commission_services_container");
    if (target) {
      target.classList.add("reduceSize3");
      audio.play();
      
      setTimeout(() => {
        target.classList.remove("reduceSize3");
      }, 300);
      
      setTimeout(() => {
        navigate("vendor-license");
      }, 600);
    }
  };

  const handleTradeLicenseClick = (e) => {
    e.preventDefault();
    const target = e.target.closest(".trade_license_container");
    if (target) {
      target.classList.add("reduceSize3");
      audio.play();
      
      setTimeout(() => {
        target.classList.remove("reduceSize3");
      }, 300);
      
      setTimeout(() => {
        if (isShopUser) {
            setSnackbarMessage("Access limited to members and merchants only.");
            setSnackbarOpen(true);
          return;
        }
        navigate("trade-license");
      }, 600);
    }
  };


  return (
    <Box className="municipal_corporation_wrapper">
      <CustomSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity="error"
        handleClose={() => setSnackbarOpen(false)}
      />
      <Box className="content">

        <Box component="img" src={bg_img} alt="municipal_corporation_image" className="bg_img"/>
        {/* Header */}
        <Box className="header">
          <Box></Box>
         
            <Box className="title_container">
              <Link to={-1} className='title_link'>
                  <Typography className="title">
                    Municipal Corporation of Amritsar
                  </Typography>
              </Link>
            </Box>
            <UserBadge
            handleLogoutClick="../../"
            handleBadgeBgClick={-1}
            handleLogin="../login"
          />
        </Box>

        <Box className="body">
          <Link className="trade_license_container" onClick={handleTradeLicenseClick} style={{ cursor: 'pointer' }}>
            <Box component="img" src={trade_license} alt="trade_license" className="trade_license_img"/>
          </Link>
          <Link className="grievance_license_container" onClick={handleGrievanceClick} style={{ cursor: 'pointer' }}>
            <Box component="img" src={grievance_form} alt="grievance_form" className="grievance_license_img"/>
          </Link>
          <Link className="services_by_municipal_corporation_container">
            <Box component="img" src={services_by_municipal_corporation} alt="services_by_municipal_corporation" className="services_by_municipal_corporation_img"/>

            <Typography className="title_heading">Services by Municipal Corporation</Typography>
          </Link>
          <Link className="vendor_commission_services_container" onClick={handleVendorClick}>
            <Box component="img" src={vendor_commission_services} alt="vendor_commission_services" className="vendor_commission_services_img"/>
          
          <Box className="vendor_commission_services_panel">
            <Box className="board_pins">
              <Box className="circle"></Box>
              <Box className="circle"></Box>
            </Box>
            <Typography className="panel_title">Vendor Licenses & Renewal</Typography>
            <Box className="board_pins">
              <Box className="circle"></Box>
              <Box className="circle"></Box>
            </Box>
          </Box>
          </Link>
        </Box>

       
      </Box>
    </Box>
  );
}

export default MunicipalCorporation;
